
var endpoint = window.location.href.split('#')[0];
endpoint = endpoint.replace('/web/', '/api');
if (endpoint.endsWith('localhost/')) {
  endpoint = "http://localhost/dev/api";
}
if (endpoint.endsWith("localhost:9999/")) {
  endpoint = "http://localhost/dev/api";
}

console.log(endpoint);

const devmode =
  window.location.href.indexOf("//localhost") !== -1 ? true : false;

module.exports = {
  socketio: false, //habilitar SOCKET IO no projeto
  socketioport: devmode ? null : 18001, //habilitar porta no projeto
  socketiodebug: false, //Debug front-end SOCKET IO chamadas-REST
  socketiotimeout: 10000, //TIMEout das requisições SOCKET IO chamadas-REST
  socketiocrud_force: false, //forçar todos os CRUDs comunicarem via SocketIO
  socketiopage_force: false, //forçar todos as pages comunicarem via SocketIO

  endpoint,
  devmode,
  metadmin: {
    resumo: {}
  }
};
//end
